import { render } from "./SaveLeaveType.vue?vue&type=template&id=f429dbb4&scoped=true"
import script from "./SaveLeaveType.vue?vue&type=script&lang=js"
export * from "./SaveLeaveType.vue?vue&type=script&lang=js"

import "./leave-type.scss?vue&type=style&index=0&id=f429dbb4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f429dbb4"]])

export default __exports__